module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-4.png?51776c41";